import { ProjectsTable } from '@/components/projects-table'
import { listAllProjects } from '@/lib/api'
import { Button } from '@magnetic/button'
import { Text } from '@magnetic/text'
import { Export, Trash } from '@/lib/icons'

export default function AdminAllProjects() {
  return (
      <ProjectsTable
        queryFn={listAllProjects}
        title="All Projects"
        description="Administrator view of all projects in the platform"
        selectableRows={true}
      bulkActions={(selectedCount) => (
        <>
          <Text size="p3">{selectedCount} selected</Text>
          <Button kind="secondary" size="sm" icon={<Export weight="bold" size={16} />}>
            Export Selected
          </Button>
          <Button kind="secondary" size="sm" destructive icon={<Trash weight="bold" size={16} />}>
            Delete Selected
          </Button>
        </>
      )}
      initialPageSize={20}
    />
  )
}
